import MainLayout from "../../layout/MainLayout";
import { Button2, Checkbox, QuickActionSelect } from "../index";
import sortIcon from "../../assets/icons/sort-icon.png";
import { DatePicker } from "antd";
import calendarIcon from "../../assets/icons/calendar-icon.png";
import { BellIcon } from "../svg-organizer/SvgOrganizer";
import plusIcon from "../../assets/icons/plus-circle-white.png";
import circleIcon from "../../assets/icons/Ellipse 81.png";
import Table from "../table/Table";
import { useNavigate } from "react-router-dom";
import { useAllGroupExpenses } from "../../data/live";

const formatDate = (value) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  return date.toLocaleDateString("en-AU");
};

const ViewByPerson = () => {
  const navigate = useNavigate();
  const { items: expenses, loading } = useAllGroupExpenses();

  const viewByPersonTableHeader = [
    <Checkbox />,
    "Group Name",
    "Expenses",
    "Date",
    "Category",
    "Tags",
    "Total",
    "You Paid",
    "You Share",
    "Received",
    "Remaining",
    "",
  ];

  const viewByPersonTableBody = expenses.map((expense) => ({
    groupdetails: {
      icon: circleIcon,
      name: expense.group?.name || "Not set",
    },
    expense: expense.description,
    date: formatDate(expense.date),
    category: expense.category || "Not set",
    tags: Array.isArray(expense.tags) ? expense.tags.join(", ") : "",
    total: Number(expense.amount || 0),
    youPaid: Number(expense.viewerSummary?.youPaid || 0),
    youShare: Number(expense.viewerSummary?.youShare || 0),
    received: Number(expense.viewerSummary?.received || 0),
    remaining: Number(expense.viewerSummary?.remaining || 0),
  }));

  return (
    <>
      <MainLayout
        expand={false}
        NavName={"Split Payment"}
        navbarChildren={<QuickActionSelect className="rounded-5" />}
      >
        <div>
          <div className="container mt-5">
            <div className="row gap-3">
              <div className="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap gap-2 gap-md-0">
                <span className="fs-5 fw-semibold">View by Person</span>
                <div className="d-flex gap-2 align-items-center flex-wrap flex-md-nowrap gap-2 gap-md-0">
                  <Button2
                    buttonName={"Sort"}
                    className={"border"}
                    divClassName={"gap-2"}
                    icon={<img src={sortIcon} alt="sort" />}
                  />
                  <DatePicker
                    className="rounded-pill w-auto"
                    suffixIcon={<img src={calendarIcon} alt="" />}
                    placeholder="Custom Date"
                  />
                  <Button2
                    buttonName={"Send Reminder"}
                    className={"btn-outline-success"}
                    icon={<BellIcon />}
                    divClassName={"gap-2"}
                    onClick={() => navigate("/reminder")}
                  />
                  <Button2
                    buttonName={"New Group"}
                    className={"btn-dark"}
                    divClassName={"gap-2"}
                    icon={<img src={plusIcon} alt="add" />}
                    onClick={() => navigate("/create-group")}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="border rounded-3 p-3 px-5">
                  {loading ? (
                    <div className="p-5 text-center text-muted">Loading people view...</div>
                  ) : viewByPersonTableBody.length ? (
                    <Table
                      className={"w-100"}
                      tableBody={viewByPersonTableBody}
                      tableHeaders={viewByPersonTableHeader}
                      ViewByPersonTable={true}
                    />
                  ) : (
                    <div className="p-5 text-center text-muted">No split expenses found.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default ViewByPerson;
